import counterfeitReport from "./counterfeitReport.api";
import counterfeitReportDetail from "./counterfeitReportDetail.api";

const counterfeitReportApi = {
  counterfeitReport,
  counterfeitReportDetail
};

export default counterfeitReportApi;
